/**
 * 站点设置适配器
 * 封装 /api/settings 接口调用
 */

import { apiClient } from './index';
import type { SiteSettings, FeaturesConfig } from '../api/types';
import { FeatureStatus } from './types';
import type { AdapterResult } from './types';

// 默认站点设置（接口不可用时的降级方案）
const DEFAULT_SITE: SiteSettings = {
  title: '弗瑞云游',
  subtitle: '让免费更自由',
  description: '弗瑞云游 - 免费云游戏平台',
  keywords: '云游戏,免费游戏,在线游戏',
  logo: '',
  favicon: '',
  icp: '',
};

// 默认功能开关（接口不可用时全部启用）
const DEFAULT_FEATURES: FeaturesConfig = {
  search: true,
  tags: true,
  categories: true,
  darkMode: true,
  comments: false,
  analytics: false,
};

export const settingsAdapter = {
  /**
   * 获取站点设置
   */
  async getSettings(): Promise<AdapterResult<{ site: SiteSettings; features: FeaturesConfig }>> {
    try {
      const data = await apiClient.getSettings();
      return {
        data,
        status: FeatureStatus.AVAILABLE,
      };
    } catch {
      return {
        data: { site: DEFAULT_SITE, features: DEFAULT_FEATURES },
        status: FeatureStatus.DEGRADED,
        message: '使用本地默认站点设置',
        fallback: true,
      };
    }
  },
};
